import { ReactNode } from 'react';
import styles from './cardAndPreview.css';
import CardContent from './CardContent';

export interface PreviewCardProps {
  children?: ReactNode;
  errorMessage?: string;
  isLoading?: boolean;
  testId?: string;
}

export const PreviewCard = (props: PreviewCardProps) => {
  const { testId } = props;
  return (
    <div className={styles.previewCard} data-test-id={`${testId}-preview-card`}>
      <CardContent {...props} />
    </div>
  );
}

export default PreviewCard;
